import { render, staticRenderFns } from "./checklist.vue?vue&type=template&id=b536ac72&"
import script from "./checklist.vue?vue&type=script&lang=ts&"
export * from "./checklist.vue?vue&type=script&lang=ts&"
import style0 from "./checklist.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports